/* 🤖 this file was generated by svg-to-ts */
export const iconEthereum: {
  name: 'ethereum';
  data: string;
} = {
  name: 'ethereum',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#ethereum__clip0_423_4)"><path fill="currentColor" fill-rule="evenodd" d="M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16S24.837 0 16 0 0 7.163 0 16m23.994.219L16.498 4 9 16.22l7.498 4.353zM24 17.616l-7.502 4.351L9 17.617l7.498 10.378z" clip-rule="evenodd"/></g><defs><clipPath id="ethereum__clip0_423_4"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
